// Number assertions
function isNumber(value) {
  return typeof value === 'number';
}

function isArray(value) {
  return Array.isArray(value);
}
var isEmptyArray = function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}; // Function assertions

function isFunction(value) {
  return typeof value === 'function';
} // Generic assertions
var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined' || value === undefined;
};
var isNull = function isNull(value) {
  return value == null;
};
var isNullOrUndefined = function isNullOrUndefined(value) {
  return isNull(value) || isUndefined(value);
}; // Object assertions

var isObject = function isObject(value) {
  var type = typeof value;
  return value != null && (type === 'object' || type === 'function') && !isArray(value);
};
var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
};

function isString(value) {
  return Object.prototype.toString.call(value) === '[object String]';
} // Event assertions

var isEmpty = function isEmpty(value) {
  if (isArray(value)) return isEmptyArray(value);
  if (isObject(value)) return isEmptyObject(value);
  if (value == null || value === '') return true;
  return false;
};
var __DEV__ = process.env.NODE_ENV !== 'production';
function isRefObject(val) {
  return 'current' in val;
}

export { __DEV__, isArray, isEmpty, isEmptyArray, isEmptyObject, isFunction, isNull, isNullOrUndefined, isNumber, isObject, isRefObject, isString, isUndefined };
//# sourceMappingURL=assertion.esm.js.map
